import { useMutation, useQuery } from '@tanstack/react-query'
import AXIOS_INSTANCE from '../api/axiosInstance'
import { queryClient } from '../store/provider/TanStackProvider'
import { DepartmentArgOptions, DepartmentResMock, DepartmentsMock } from '../types/department.types'

export const useDepartment = (arg?: DepartmentArgOptions) => {
  const departmentId = arg?.id
  const page = arg?.page
  const pageSize = arg?.limit
  const query = arg?.query

  let endpoint = `departments?`

  if (page) endpoint = `${endpoint}page%5Bnumber%5D=${page}&page%5Bsize%5D=${pageSize}`
  if (query) endpoint = `${endpoint}&query=${query}`

  const { data: departments, isLoading } = useQuery({
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<DepartmentResMock<DepartmentsMock[]>>(endpoint)
      return data
    },
    queryKey: ['department', departmentId, page, pageSize, query]
  })

  const { data: singleDepartment } = useQuery({
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<DepartmentResMock<DepartmentsMock>>(`departments/${departmentId}`)
      return data.data
    },
    queryKey: ['department', departmentId]
  })

  const { mutateAsync: addDepartment } = useMutation({
    mutationFn: async (formVal: any) => {
      const { data } = await AXIOS_INSTANCE.post(`departments/`, formVal, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
      return data
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['department'] })
  })

  const { mutateAsync: updateDepartment } = useMutation({
    mutationFn: async ({ data, id }: { data: any; id: string }) => {
      await AXIOS_INSTANCE.patch(`departments/${id}`, data, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['department'] })
  })

  const { mutateAsync: deleteDepartment } = useMutation({
    mutationFn: async (id: string) => {
      await AXIOS_INSTANCE.delete(`departments/${id}`)
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['department'] })
  })

  return {
    addDepartment,
    deleteDepartment,
    isLoading,
    departmentCount: departments?.meta.pagination,
    departments: departments?.data,
    included: departments?.included,
    singleDepartment,
    updateDepartment
  }
}
